module.exports = __webpack_public_path__ + "media/images/products/google-play-a10a21b1ef8105af3a36077d35de5f5f.svg";